module.exports = __webpack_public_path__ + "static/media/share.624a6f81.jpg";